import { createSlice } from "@reduxjs/toolkit";
import { getInitialAuthState } from "../helpers/auth";

export const authSlice = createSlice({
  name: "auth",
  initialState: getInitialAuthState(),

  reducers: {
    login: (_, action) => {
      return {
        isAuthenticated: true,
        user: action.payload,
      };
    },

    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },

    setMechanicData: (state, action) => {
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    },
  },
});

// action creators
export const { login, logout, setMechanicData } = authSlice.actions;

export default authSlice.reducer;

export const selectMechanicId = (state) => state.auth.user?.id;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectMechanicType = (state) => state.auth.user?.type;
export const selectMechanicBalance = (state) => state.auth.user?.balance;
export const selectIsWeeklyBonusEnabled = (state) =>
  state.auth.user?.isWeeklyBonusEnabled;
export const selectIsPricesBlurred = (state) => state.auth.user?.isPricesBlured;
export const selectMechanicDefaultBranch = (state) =>
  state.auth.user?.branches.find((branch) => branch.isDefault);
export const selectMechanicDefaultBranchName = (state) =>
  state.auth.user?.branches.find((branch) => branch.isDefault)?.name;
export const selectMechanicDefaultBranchId = (state) =>
  state.auth.user?.branches.find((branch) => branch.isDefault)?.id;
export const selectNotDefaultMechanicBranches = (state) =>
  state.auth.user?.branches.filter((branch) => !branch.isDefault);
export const selectMechanicBranches = (state) => state.auth.user?.branches;
